import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackComponentComponent } from "../components/snack-component/snack-component.component";

@Injectable({
  providedIn: "root",
})
export class SnackService {
  constructor(private snackBar: MatSnackBar) {}

  dismiss() {
    this.snackBar.dismiss();
  }

  openComponent(c) {
    return this.snackBar.openFromComponent(c, {
      panelClass: ["component-snackbar"],
    });
  }

  success(message: string) {
    this.snackBar.open(message, "Ok", {
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["success-snackbar"],
    });
  }

  error(message: string) {
    this.snackBar.open(message, "Ok", {
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["error-snackbar"],
    });
  }

  warn(message: string) {
    this.snackBar.open(message, "Ok", {
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["warn-snackbar"],
    });
  }

  info(message: string) {
    this.snackBar.open(message, "Ok", {
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right",
      panelClass: ["info-snackbar"],
    });
  }

  successWithAction(
    messages: string[],
    buttonText: string,
    buttonFunction: () => void,
    buttonIcon?: string,
  ) {
    const snackBarRef = this.snackBar.openFromComponent(
      SnackComponentComponent,
      {
        duration: 6000,
        verticalPosition: "top",
        horizontalPosition: "right",
        panelClass: ["success-snackbar"],
      },
    );
    snackBarRef.instance.messages.set(messages);
    snackBarRef.instance.buttonFunction.set(buttonFunction);
    snackBarRef.instance.buttonText.set(buttonText);
    snackBarRef.instance.buttonIcon.set(buttonIcon);
  }

  errorWithAction(
    messages: string[],
    buttonText: string,
    buttonFunction: () => void,
    buttonIcon?: string,
  ) {
    const snackBarRef = this.snackBar.openFromComponent(
      SnackComponentComponent,
      {
        duration: 8000,
        verticalPosition: "top",
        horizontalPosition: "right",
        panelClass: ["error-snackbar"],
      },
    );
    snackBarRef.instance.messages.set(messages);
    snackBarRef.instance.buttonFunction.set(buttonFunction);
    snackBarRef.instance.buttonText.set(buttonText);
    snackBarRef.instance.buttonIcon.set(buttonIcon);
  }

  infoWithAction(
    messages: string[],
    buttonText: string,
    buttonFunction: () => void,
    buttonIcon?: string,
  ) {
    const snackBarRef = this.snackBar.openFromComponent(
      SnackComponentComponent,
      {
        duration: 6000,
        verticalPosition: "top",
        horizontalPosition: "right",
        panelClass: ["info-snackbar"],
      },
    );
    snackBarRef.instance.messages.set(messages);
    snackBarRef.instance.buttonFunction.set(buttonFunction);
    snackBarRef.instance.buttonText.set(buttonText);
    snackBarRef.instance.buttonIcon.set(buttonIcon);
  }
}
